export interface KamenyBetOption {
    id: number;
    multiplier: number;
    value?: number;
    text?: string;
    jackpotKey?: string;
    summaryDisplayOrder?: number;
}

export const KAMENY_NUMBERS: KamenyBetOption[] = [
    { id: 1, value: 6, multiplier: 25000 },
    { id: 2, value: 7, multiplier: 4400 },
    { id: 3, value: 8, multiplier: 1250 },
    { id: 4, value: 9, multiplier: 474 },
    { id: 5, value: 10, multiplier: 210 },
    { id: 6, value: 11, multiplier: 105 },
    { id: 7, value: 12, multiplier: 55 },
    { id: 8, value: 13, multiplier: 35 },
    { id: 9, value: 14, multiplier: 22 },
    { id: 10, value: 15, multiplier: 15 },
    { id: 11, value: 16, multiplier: 12 },
    { id: 12, value: 17, multiplier: 9 },
    { id: 13, value: 18, multiplier: 8 },
    { id: 14, value: 19, multiplier: 7 },
    { id: 15, value: 20, multiplier: 6 },
    { id: 16, value: 21, multiplier: 6 },
    { id: 17, value: 22, multiplier: 6 },
    { id: 18, value: 23, multiplier: 7 },
    { id: 19, value: 24, multiplier: 8 },
    { id: 20, value: 25, multiplier: 9 },
    { id: 21, value: 26, multiplier: 12 },
    { id: 22, value: 27, multiplier: 15 },
    { id: 23, value: 28, multiplier: 22 },
    { id: 24, value: 29, multiplier: 35 },
    { id: 25, value: 30, multiplier: 55 },
    { id: 26, value: 31, multiplier: 105 },
    { id: 27, value: 32, multiplier: 210 },
    { id: 28, value: 33, multiplier: 474 },
    { id: 29, value: 34, multiplier: 1250 },
    { id: 30, value: 35, multiplier: 4400 },
    { id: 31, value: 36, multiplier: 25000 },
];

export const KAMENY_COMBOS: KamenyBetOption[] = [
    { id: 38, text: "Jedničky", multiplier: 25000, jackpotKey: "kombinace_jedničky_5kc", summaryDisplayOrder: 32 },
    { id: 32, text: "Šestice", multiplier: 4400, jackpotKey: "kombinace_šestice_5kc", summaryDisplayOrder: 38 },
    { id: 39, text: "Dvojky", multiplier: 25000, jackpotKey: "kombinace_dvojky_5kc", summaryDisplayOrder: 33 },
    { id: 33, text: "Pětice", multiplier: 147, jackpotKey: "kombinace_pětice_5kc", summaryDisplayOrder: 39 },
    { id: 40, text: "Trojky", multiplier: 25000, jackpotKey: "kombinace_trojky_5kc", summaryDisplayOrder: 34 },
    { id: 34, text: "Čtveřice", multiplier: 12, jackpotKey: "kombinace_čtveřice_5kc", summaryDisplayOrder: 40 },
    { id: 41, text: "Čtyřky", multiplier: 25000, jackpotKey: "kombinace_čtyřky_5kc", summaryDisplayOrder: 35 },
    { id: 35, text: "2x&nbsp;Trojice", multiplier: 88, jackpotKey: "kombinace_2xtrojice_5kc", summaryDisplayOrder: 41 },
    { id: 42, text: "Pětky", multiplier: 25000, jackpotKey: "kombinace_pětky_5kc", summaryDisplayOrder: 36 },
    { id: 36, text: "3x&nbsp;Dvojice", multiplier: 14, jackpotKey: "kombinace_3xdvojice_5kc", summaryDisplayOrder: 42 },
    { id: 43, text: "Šestky", multiplier: 25000, jackpotKey: "kombinace_šestky_5kc", summaryDisplayOrder: 37 },
    { id: 37, text: "1;2;3;4;5;6", multiplier: 36, jackpotKey: "kombinace_1;2;3;4;5;6_5kc", summaryDisplayOrder: 43 },
    { id: 46, text: "1;2;3", multiplier: 36, jackpotKey: "kombinace_1;3;5_5kc", summaryDisplayOrder: 47 },
    { id: 44, text: "2;4;6", multiplier: 36, jackpotKey: "kombinace_2;4;6_5kc", summaryDisplayOrder: 44 },
    { id: 45, text: "1;3;5", multiplier: 36, jackpotKey: "kombinace_1;2;3_5kc", summaryDisplayOrder: 45 },
    { id: 47, text: "4;5;6", multiplier: 36, jackpotKey: "kombinace_4;5;6_5kc", summaryDisplayOrder: 46 },
];
